export const ESTIMATE_STORAGE_KEY = "layable_estimate_uuids_v1";
export const ESTIMATE_FILE_NAMES_STORAGE_KEY = "layable_estimate_file_names_v1";
const MAX_SAVED_ESTIMATES = 100;

export const loadEstimateIds = (storage = window.localStorage) => {
  try {
    const value = JSON.parse(storage.getItem(ESTIMATE_STORAGE_KEY) || "[]");
    if (!Array.isArray(value)) return [];
    return [...new Set(value.filter((item) => typeof item === "string" && item.length > 0))].slice(0, MAX_SAVED_ESTIMATES);
  } catch {
    return [];
  }
};

export const saveEstimateIds = (ids, storage = window.localStorage) => {
  const normalized = [...new Set(ids.filter((item) => typeof item === "string" && item.length > 0))].slice(0, MAX_SAVED_ESTIMATES);
  storage.setItem(ESTIMATE_STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
};

export const rememberEstimateId = (uuid, storage = window.localStorage) => {
  if (!uuid) return loadEstimateIds(storage);
  return saveEstimateIds([uuid, ...loadEstimateIds(storage)], storage);
};

export const loadEstimateFileNames = (storage = window.localStorage) => {
  try {
    const value = JSON.parse(storage.getItem(ESTIMATE_FILE_NAMES_STORAGE_KEY) || "{}");
    if (!value || Array.isArray(value) || typeof value !== "object") return {};
    return Object.fromEntries(
      Object.entries(value).filter(
        ([uuid, fileName]) => typeof uuid === "string" && uuid.length > 0 && typeof fileName === "string" && fileName.length > 0
      )
    );
  } catch {
    return {};
  }
};

export const rememberEstimateFileName = (uuid, fileName, storage = window.localStorage) => {
  if (!uuid || !fileName) return loadEstimateFileNames(storage);
  const fileNames = { ...loadEstimateFileNames(storage), [uuid]: fileName };
  storage.setItem(ESTIMATE_FILE_NAMES_STORAGE_KEY, JSON.stringify(fileNames));
  return fileNames;
};

export const forgetEstimateFileName = (uuid, storage = window.localStorage) => {
  const fileNames = loadEstimateFileNames(storage);
  delete fileNames[uuid];
  storage.setItem(ESTIMATE_FILE_NAMES_STORAGE_KEY, JSON.stringify(fileNames));
  return fileNames;
};

export const forgetEstimateId = (uuid, storage = window.localStorage) => {
  const ids = saveEstimateIds(
    loadEstimateIds(storage).filter((savedUuid) => savedUuid !== uuid),
    storage
  );
  forgetEstimateFileName(uuid, storage);
  return ids;
};
